import { useSlideshow } from '@/hooks/useSlideshow'
import { CONFIG } from '@/config/constants'

const slides = [
  { src: '/assets/img/making_image_1.jpg', alt: 'パン作りの様子1' },
  { src: '/assets/img/making_image_2.jpg', alt: 'パン作りの様子2' },
  { src: '/assets/img/making_image_3.jpg', alt: 'パン作りの様子3' },
  { src: '/assets/img/making_image_4.jpg', alt: 'パン作りの様子4' },
  { src: '/assets/img/product_bread_2.jpg', alt: 'パン商品2' },
]

export function Hero() {
  const { currentSlide, goToSlide, hoverHandlers } = useSlideshow({
    totalSlides: slides.length,
    interval: CONFIG.SLIDESHOW.autoPlayInterval,
  })

  return (
    <section id="home" className="hero">
      {/* Hero Slideshow */}
      <div className="hero-slideshow" {...hoverHandlers}>
        {slides.map((slide, index) => (
          <div
            key={slide.src}
            className={`slide ${index === currentSlide ? 'active' : ''}`}
          >
            <img src={slide.src} alt={slide.alt} className="slide-image" />
          </div>
        ))}

        {/* Slide indicators */}
        <div className="slide-indicators">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`indicator ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              role="button"
              aria-label={`スライド ${index + 1} に移動`}
            ></span>
          ))}
        </div>
      </div>

      <div className="hero-content">
        <div className="hero-title">
          <img
            src="/assets/img/kamando_logo_alpha.png"
            alt="Kamando"
            className="hero-logo"
          />
        </div>
        <p>香ばしいかおりに包まれる、ちょっと贅沢な日常を。</p>
      </div>

      <a href="#products" className="scroll-indicator">
        <div className="scroll-text-en">see more</div>
        <div className="scroll-arrow">
          <div className="chevron-left"></div>
          <div className="chevron-right"></div>
        </div>
      </a>
    </section>
  )
}
